import React, {Component} from 'react';
import { loadDashboard, isAfterDate, isBeforeDate, isBetweenDates, hasPerm, getCurrentAssignment, loadObjectWith, AuthenticatedUser, stopTimer, authenticate} from "../../api";
import { Calendar, PenTool, List, UserMinus, HelpCircle, Video, ShoppingCart, Sliders } from 'react-feather';
import BDBQueryCube from '../../pages/pageParts/bdbQueryCube';
import PageCloser from '../../common/pageCloser'
import Countdown from '../../common/countdown'
import TournamentPageTemplate from './tournamentPageTemplate'
import TournamentBanner from './tournamentBanner'
import TournamentGuide from './tournamentGuide'
import moment from 'moment';

class TournamentPager extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.updateProfile = this.updateProfile.bind(this);

        this.state = {
            loading: true,
            user: user,
            tData: {},
            newUser: {accountType: null},
            pid: params.pid,
        }

    }

    loadTournamentPage = (pid) => {       
        if (!pid) pid = this.state.pid;
        if (pid) {
            loadObjectWith('tournamentPage', 'adhmstq', pid).then( async d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                    this.setState({ loading: false});
                } else { 
                    const tUser = d2.tUser ? d2.tUser : {
                        tournamentId: d2.tournamentPage._id,
                        userId: this.state.user._id,
                        displayname: this.state.user.displayname,
                        status: 'New'
                    }                                     
                    loadDashboard(this.state.user._id).then( d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                            this.setState({pid: pid, tData: d2.tournamentPage, tUser: tUser, roomJson: JSON.parse(d2.tournamentPage.roomJson), loading: false}); 
                        } else {
                            const jwt = AuthenticatedUser();
                            jwt.user = d3;
                            authenticate(jwt, () => {
                                this.setState({pid: pid, tData: d2.tournamentPage, tUser, user: AuthenticatedUser().user, roomJson: JSON.parse(d2.tournamentPage.roomJson), loading: false});  
                            });                            
                   
                        }
                    });
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {

        this.loadTournamentPage();               
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
        if (prevProps.location.key !== this.props.location.key) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }
    
    updateProfile(tUser) {
        this.setState({tUser} )
    }
    
    render(){
        if (this.state.loading) { return null; }
        
        stopTimer();      
        const { tData, user, tUser, roomJson } = this.state;
        if (!tUser) {
            return <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "25px"}}>You have been logged out.  Please login.</p>
        }



        const judgeAssignment = tUser.isJudge ? getCurrentAssignment(tUser) : null; 
        const hasTournamentStarted = tData && tData.rounds ? tData.rounds.find(x=>x.status && x.status !== 'new') : false;

        var showAdmin = hasPerm(user, tData.permTags[0]);
        //var showAdmin = (tUser.isProfileComplete && tUser.judgeClass === 'admin');
        var showJudge = (tUser.isProfileComplete && tUser.isJudge);
        var showComp = (tUser.isProfileComplete && tUser.isCompetitor) ;
        var showGuest = (tUser.isProfileComplete && tUser.isGuest) ;

        const isAnnouncing = tData.rounds.find(x=>x.isAnnouncing);
        const announcementRoom = roomJson ? roomJson.find(x=>x.tags.includes('announcements')) : null;
        /*
        if (!(tUser.isJudge || tUser.isCompetitor || tUser.isGuest)) status = "New";
        else {
            if (tUser.isJudge) status = "Active"
            if (tUser.isGuest) status = "Observing"
            if (tUser.isCompetitor) status = createAgRegistrationStatus(tUser)
        }
        */

        // if perms not known yet, show intro
        //var showIntro = (!showJudge && !showAdmin && !showComp);
        return (
            <>

            <TournamentPageTemplate pid={this.state.pid} tData={tData} tUser={tUser} user={user} title3=""
                bcTitle={tData.title} content={tData.content} headerImage={tData.imageUrl}
            >                                             
            <div className="container-fluid">  
                <TournamentBanner pid={this.state.pid} tData={tData} tUser={tUser} user={user} subtitle={tData.subtitle}
                    bcTitle={tData.title} content={tData.content} headerImage={tData.imageUrl} onUpdate={this.updateProfile}
                /> 

                {user.isLoggedIn && tUser.status !== 'New' && !showAdmin &&
                    <TournamentGuide tData={tData} user={user} tUser={tUser} onUpdate={this.updateProfile}/>                    
                }
                                        
                <hr/>

                {isAnnouncing &&
                    <PageCloser 
                        header="Hope your tournament is going splendidly!"
                        message={<>Announcements are being mad in the Announcements Room.  <p style={{fontSize: "28px"}}>Go there now by clicking <a target='_blank' rel="noopener noreferrer" href={announcementRoom.link}>here</a>.</p></>}
                        symbol="fa fa-bullhorn"
                    />                         
                }

                {showGuest && 
                <div className="row">
                    {tData.guestHelpPageId && <BDBQueryCube colClass title="Guest Instructions" subtitle="Start here for information" qType="none" link={`/pages/lp/${tData.guestHelpPageId}`} icon={<HelpCircle className="font-success" />} bg="bg-success" /> }
                    {tUser.status === "Observing" && <>
                        {isBetweenDates(new Date(), new Date(tData.startDate), new Date(tData.endDate)) &&                            
                        <>
                            <BDBQueryCube colClass title="Review Postings" qType="none" link={`/tournament/postings/${tData._id}`} icon={<List className="font-primary" />} bg="bg-primary" />
                        
                        {roomJson.filter(x=>x.permissions.includes("GUEST-0")).map(x=>
                        <BDBQueryCube colClass title={x.title} subtitle={x.subtitle} href={x.link} qType="none" icon={<Video className={`font-${x.color}`} />} bg={`bg-${x.color}`} />
                        )}

                        </>
                        }
                    </> 
                    }
                </div>
                }

                
                {showComp && 
                <div className="row">
                    {tData.competitorHelpPageId && <BDBQueryCube colClass title="Competitor Instructions" subtitle="Start here for information" qType="none" link={`/pages/lp/${tData.competitorHelpPageId}`} icon={<HelpCircle className="font-success" />} bg="bg-success" />}

                    {!hasTournamentStarted && isBetweenDates(new Date(), new Date(tData.startRegDate), new Date(tData.endRegDate)) &&
                    <BDBQueryCube colClass title="Register for Events" subtitle="My Event Count" data={tUser.events ? tUser.events.filter(x=>x.isRegistered && x.isPaid).length : 0} qType="number"  link={`/tournament/events/${tData._id}`} icon={<ShoppingCart className="font-primary" />} bg="bg-primary" />
                    }

                    {isBetweenDates(new Date(), new Date(tData.startDate), new Date(tData.endDate)) &&                            
                    <>
                        <BDBQueryCube colClass title="Review Postings"  qType="none" link={`/tournament/postings/${tData._id}`} icon={<List className="font-primary" />} bg="bg-primary" />
                    
                    {roomJson.filter(x=>x.permissions.includes("COMP-0")).map(x=>
                    <BDBQueryCube colClass title={x.title} subtitle={x.subtitle} href={x.link} qType="none" icon={<Video className={`font-${x.color}`} />} bg={`bg-${x.color}`} />
                    )}

                    </>
                    }

                    {(isAfterDate(new Date(), new Date(tData.endDate))) &&                            
                    <>
                        <BDBQueryCube colClass title="Ballots" altsubtitle="" qType="none"
                        subtitle={"Review your ballots"}
                        link={`/tournament/competitor/ballots/${tData._id}`} 
                        icon={<UserMinus className="font-primary" />} bg="bg-primary" /> 
                    </>
                    }   

                </div>
                }

                {showJudge  &&
                <div className="row">                                     
                    {tData.judgeHelpPageId && <BDBQueryCube colClass title="Judge Instructions" subtitle="Start here for information" qType="none" link={`/pages/lp/${tData.judgeHelpPageId}`} icon={<HelpCircle className="font-success" />} bg="bg-success" />}

                    {isBetweenDates(new Date(), new Date(tData.endRegDate), new Date(tData.endDate)) &&                            
                    <>

                        <BDBQueryCube colClass title="Conflicts of Interest" altsubtitle="Ready" qType="none"
                        subtitle={"Set competitors you cannot judge"}
                        link={`/tournament/competitor/exceptions/${tData._id}`} 
                        icon={<UserMinus className="font-primary" />} bg="bg-primary" /> 
                    </>
                    }   

                    {judgeAssignment &&
                        <BDBQueryCube colClass title="Go to My Room" qType="none" subtitle= "Go to your assigned room"
                        link={`/tournament/room/${tData._id}/${judgeAssignment.roomId}`} 
                        icon={<PenTool className="font-primary"/>} bg="bg-primary"/>
                    }

                    {isBetweenDates(new Date(), new Date(tData.startDate), new Date(tData.endDate)) &&                            
                    <>
                        <BDBQueryCube colClass title="Review Postings"   qType="none" link={`/tournament/postings/${tData._id}`} icon={<List className="font-primary" />} bg="bg-primary" />
                    
                        {roomJson.filter(x=>x.permissions.includes("JUDGE-0")).map(x=>
                        <BDBQueryCube colClass title={x.title} subtitle={x.subtitle} href={x.link} qType="none" icon={<Video className={`font-${x.color}`} />} bg={`bg-${x.color}`} />
                        )}
                    </>
                    }
                                            
                </div>
                }

                {showAdmin &&    
                <div className="row">                    
                        <BDBQueryCube colClass title="Administration" subtitle="Administer the tournament"  qType="none" link={`/tournament/admin/${tData._id}`} icon={<Sliders className="font-danger" />} bg="bg-danger" />                            
                        {/*<BDBQueryCube colClass title="Configuration" subtitle="Configure the tournament"  qType="none" link={`/tournament/config/${tData._id}`} icon={<Sliders className="font-danger" />} bg="bg-danger" /> */}
                </div>
                } 

                {isBeforeDate(new Date(), new Date(tData.startRegDate)) &&
                <PageCloser 
                    header="Tournament Has not opened for Registration yet."
                    message={
                        <>
                        <p>Registration opens: <br/><br /><h3>{moment(tData.startRegDate).format('lll')}</h3></p>
                        <p>You may create your free account and setup a profile while you wait for registration to open.</p>
                        <Countdown date={new Date(tData.startRegDate)} />
                        </>
                        }
                />
                }

                {isBetweenDates(new Date(), new Date(tData.startRegDate), new Date(tData.endRegDate)) &&
                <PageCloser 
                    header="Tournament Registration is Open"
                    message={
                        <>
                        Registration Closes: <br/><br /><h3>{moment(tData.endRegDate).format('lll')}</h3>
                        You will need to register and pay before registration closes in order to compete in this tournament.
                        <Countdown date={new Date(tData.endRegDate)} />
                        </>
                        }
                />
                }

                {isBetweenDates(new Date(), new Date(tData.endRegDate), new Date(tData.startDate)) &&
                <PageCloser 
                    header="Tournament Hall is not open yet ..."
                    message={
                        <>
                        We will open the Student Hangout and Announcements hall at: <br/><br /><h3>{moment(tData.startDate).format('lll')}</h3>
                        Hang Out and Announcements Room cards will show up at that time.  
                        <Countdown date={new Date(tData.startDate)} />
                        </>
                        }
                />
                }

                {isAfterDate(new Date(), new Date(tData.endDate)) &&
                <PageCloser 
                    header="Results of Tournament"
                    symbol="fa fa-trophy"
                    message={
                        <table className="table cart-table table-responsive-xs">
                            <thead>
                                <tr className="table-head">
                                    <th scope="col">Event</th>
                                    <th scope="col">Place</th>
                                    <th scope="col">Name</th>
                                </tr>
                            </thead>
                            <tbody> 
                            {tData.results && tData.results.map(x=> {
                            return (                               
                                <tr>
                                    <td style={{textAlign: "left", paddingRight: "20px"}}>{x.event}</td>
                                    <td style={{textAlign: "center", paddingRight: "20px"}}>
                                        {x.index}<sup>
                                        { x.index === 3 ? "rd"
                                        : x.index === 2 ? "nd"
                                        : x.index === 1 ? "st" : "th"
                                        }</sup> Place                                                               
                                    </td>
                                    <td style={{textAlign: "left", paddingRight: "20px"}}>{x.displayname}</td>
                                </tr>
                            )
                            })}
                            </tbody>
                        </table>
                    }
                />
                }
                    
            </div>
            
        </TournamentPageTemplate>
        
        </>

        )
    }
}

export default TournamentPager;
